import { IHoverReportTableData } from '../interfaces/IHoverReportTableData';
import { IPricingTableHeader } from '../interfaces/IPricingTableHeader';
import { URLS } from './marketingSiteLinks';

export const HOVER_REPORTS_TABLE_DATA: IHoverReportTableData[] = [
  {
    id: 0,
    title: 'Roof footprints',
    roofOnly: true,
    completeReport: true,
  },
  {
    id: 1,
    title:
      'Roof facets, pitches, ridges/hips, valleys, rakes, eaves, flashing, step flashing, drip edge/perimeter',
    roofOnly: true,
    completeReport: true,
  },
  {
    id: 2,
    title: 'Soffit footprint with the depth, length and area for each soffit',
    roofOnly: true,
    completeReport: true,
  },
  {
    id: 3,
    title: 'Gutters and downspout sketch, count and length',
    roofOnly: false,
    completeReport: true,
  },
  {
    id: 4,
    title: 'Areas for each facade and siding per elevation',
    roofOnly: false,
    completeReport: true,
  },
  {
    id: 5,
    title: 'Facades, elevations',
    roofOnly: false,
    completeReport: true,
  },
  {
    id: 6,
    title: 'Area and length for level starter, sloped trim and vertical trim',
    roofOnly: false,
    completeReport: true,
  },
  {
    id: 7,
    title: 'Quantity and length for inside and outside corners',
    roofOnly: false,
    completeReport: true,
  },
  {
    id: 8,
    title: 'Siding waste factor calculations',
    roofOnly: false,
    completeReport: true,
  },
  {
    id: 9,
    title:
      'Areas and length for eaves fascia, level frieze board, rakes and sloped frieze boars',
    roofOnly: false,
    completeReport: true,
  },
  {
    id: 10,
    title:
      'Quantity, tops length, sills length, sides length, total perimeter, width and height, united inches and area for all openings',
    roofOnly: false,
    completeReport: true,
  },
  {
    id: 11,
    title: 'Quantity and area for shutters and vents',
    roofOnly: false,
    completeReport: true,
  },
  {
    id: 12,
    title: 'Elevation sketches',
    roofOnly: false,
    completeReport: true,
  },
];

export const HOVER_REPORTS_TABLE_HEADER: IPricingTableHeader[] = [
  {
    id: 0,
    name: 'ROOF-ONLY REPORT',
    description: 'Good for quick roof measurements',
    buttonText: 'Contact sales',
    linkTo: URLS.hoverReports.contactSales,
    background: 'green.100',
    isExternal: true,
  },
  {
    id: 1,
    name: 'COMPLETE REPORT',
    description: 'Better for detailed exterior measurements',
    buttonText: 'Contact sales',
    linkTo: URLS.hoverReports.contactSales,
    background: 'primary.100',
    isExternal: true,
  },
];
